import {SecurityService} from "./security.service";

export function initApp(config: SecurityService){
    return () => {
        return config.load();
    }
}